export const TWO_FACTOR_TYPE = {
    WEB: 'W',
    EMAIL: 'E',
    CELLPHONE: 'H',
    EMAIL_OR_CELLPHONE: 'S',
}
export const TWO_FACTOR_ERR_CD = {
    NO_PROBLEM: '0000',

}